import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import CryptoJS from 'crypto-js'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 全局加密密钥
Vue.prototype.$encryptionKey = 'your-secret-key'

// 全局加密方法
Vue.prototype.$encrypt = function(data) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), this.$encryptionKey).toString()
}

// 全局解密方法
Vue.prototype.$decrypt = function(encryptedData) {
  const bytes = CryptoJS.AES.decrypt(encryptedData, this.$encryptionKey)
  return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 